import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Box, Button, Card, CardActions, CardContent, Chip, CircularProgress, IconButton, Typography } from '@mui/material';
import React, { Component } from 'react';

import { ExerciseSearchItem } from '../../api/exercises.interface';
import ExerciseHoverVideoTitle from './ExerciseHoverVideoTitle';

interface Props {
    deletingTag?: number;
    item: ExerciseSearchItem;
    selectedExerciseTags?: number[];
    selectionMode: 'none' | 'single' | 'multiple';
    onDeleteExercise: (item: ExerciseSearchItem) => void;
    onEditExercise: (index: number) => void;
    onSelectExercise?: (item: ExerciseSearchItem) => void;
}

class ExerciseResultCard extends Component<Props> {
    onDeleteClick = () => {
        this.props.onDeleteExercise(this.props.item);
    };

    onEditClick = () => {
        this.props.onEditExercise(this.props.item.index);
    };

    onSelectClick = () => {
        this.props.onSelectExercise?.(this.props.item);
    };

    render() {
        const { deletingTag, item, selectedExerciseTags, selectionMode } = this.props;
        const deletingThisCard = deletingTag === item.tag;
        const alreadySelected = Boolean(selectedExerciseTags?.includes(item.tag));

        return (
            <Card sx={{ borderRadius: 3 }} variant="outlined">
                <CardContent>
                    <Box sx={{ alignItems: 'flex-start', display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                        <Box>
                            <ExerciseHoverVideoTitle title={item.exercise} titleVariant="h6" videoUrl={item.videoUrl} />
                            <Typography color="text.secondary" variant="body2">Tag {item.tag}</Typography>
                        </Box>
                        <Chip label={item.level} size="small" />
                    </Box>
                    <Box sx={{ display: 'grid', gap: 1.5, gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' }}>
                        <Typography variant="body2"><strong>Plan:</strong> {item.plan}</Typography>
                        <Typography variant="body2"><strong>Reps:</strong> {item.reps}</Typography>
                        <Typography variant="body2"><strong>Weight:</strong> {item.weight}</Typography>
                        <Typography variant="body2"><strong>Range:</strong> {item.weightRange}</Typography>
                    </Box>
                </CardContent>
                <CardActions sx={{ justifyContent: 'flex-end', px: 2, pb: 2 }}>
                    {selectionMode === 'single' && <Button onClick={this.onSelectClick} variant="contained">Select</Button>}
                    {selectionMode === 'multiple' && (
                        <Button disabled={alreadySelected} onClick={this.onSelectClick} variant="contained">
                            {alreadySelected ? 'Added' : 'Add'}
                        </Button>
                    )}
                    {selectionMode === 'none' && (
                        <>
                            <IconButton color="primary" onClick={this.onEditClick}><EditOutlinedIcon /></IconButton>
                            <IconButton color="error" disabled={deletingThisCard} onClick={this.onDeleteClick}>
                                {deletingThisCard ? <CircularProgress size={18} /> : <DeleteOutlineRoundedIcon />}
                            </IconButton>
                        </>
                    )}
                </CardActions>
            </Card>
        );
    }
}

export default ExerciseResultCard;